<template>
    <div class="author-info">
        <div class="author">{{ guide.article.authorName }}</div>
        <div class="articleStats">{{$filters.formatNumber(guide.article.pageViews)}} views</div>
    </div>
</template>

<script src="./guide-authorinfo.js"></script>

<style lang="scss">
@use './guide-authorinfo.scss' as *;
</style>
